import React from 'react';
import {Controller} from 'react-hook-form';
import DefaultLoadingComponent from './DefaultLoadingComponent';
import useBSSController from '../../hooks/useBSSController';
import useInitialLoader from '../../hooks/useInitialLoader';
import {ButtonGroup, Button, Select, MenuItem, InputLabel, FormControl} from '@mui/material'
import useBSSLogger from '../../hooks/useBSSLogger';

const {logger} = useBSSLogger();


/**
 * 
 * @param {BssSelectProps} param0 
 * @returns 
 */
const BSSSelect = ({ 
    name,
    label = name,
    dataProvider = [], 
    methods,
    dependsOn = null,
    LoadingComponent = DefaultLoadingComponent,
    ControllerProps = {},
    ButtonGroupProps = {}
}) => {

    const {loading, error, data: options} = useInitialLoader({name, dataProvider})

    const {classes, control, dipendenze, disabilitaByDep, defaultValue} = useBSSController({name, defaultValue: options?.[0] ?? null, dependsOn, methods})


    return (
        <>

            {loading && <LoadingComponent />}
            {error && `Si è verificato un errore ${error}`}
            {(!error && !loading && options?.length) && (
                <>  
                    {/* <pre>{JSON.stringify(options, null, 2)}</pre> */}
                    <Controller
                        name={name}
                        control={control}     
                        defaultValue={defaultValue}                                           
                        render={({field: {value, onChange}, fieldState}) => (
                            <>
                                <FormControl fullWidth>
                                    <InputLabel id={`bssselect_${name}`}>{label}</InputLabel>
                                    <Select labelId={`bssselect_${name}`} label={label} 
                                        size='small' MenuProps={{disablePortal: true}}
                                        value={value}
                                        fullWidth
                                        onChange={e => {                                        
                                            onChange(e.target.value);
                                            logger.debug("cambio valore select", label, defaultValue, e, value);
                                        }}
                                    >
                                        {(options ?? []).map((option, index) => (
                                            <MenuItem key={index} 
                                                value={option.value}
                                            >
                                                {option.label}   
                                            </MenuItem> 
                                        ))}   
                                    </Select>
                                </FormControl>
                            </>
                        )}
                        {...ControllerProps}        
                    />
                </>
            )}            
        </>
    )
}

export default BSSSelect;